<template>
  <subject-form
    v-model="form"
    :max="chapter.ordered_subjects_ids.length"
    class="max-w-3xl bg-white"
    :edit="true"
    @submit="submit"
  >
    <div class="flex items-center justify-end border-t px-8 py-4">
      <loading-button
        :loading="loading"
        :progress="loadingProgress"
        class="btn-teal ml-auto"
        type="submit"
      >
        Update Subject
      </loading-button>
    </div>
  </subject-form>
</template>

<script>
import LoadingButton from '@/Shared/LoadingButton.vue';
import SubjectForm from './Form.vue';
import omit from 'lodash/omit';
import axios from 'axios';

export default {
  components: {
    LoadingButton,
    SubjectForm,
  },
  props: {
    subject: {
      type: Object,
      required: true,
    },
    chapter: {
      type: Object,
      required: true,
    },
  },
  emits: ['success'],
  data() {
    return {
      form: this.$inertia.form({
        subject: omit(this.subject, 'id'),
        position:
          this.chapter.ordered_subjects_ids.findIndex(
            (elem) => elem == this.subject.id,
          ) + 1,
        remove_documents: [],
        remove_poster: false,
        quiz_questions: this.subject.quiz_questions || [],
      }),
      loading: false,
      loadingProgress: 0,
    };
  },
  created() {
    const t = this.form.subject.texts;
    if (!t) {
      this.form.subject.texts = [];
    } else if (typeof t === 'object') {
      this.form.subject.texts = Object.keys(t)
        .sort((a, b) => parseInt(a) - parseInt(b))
        .map((k) => t[k]);
    }
  },
  methods: {
    async submit() {
      try {
        this.loading = true;
        let self = this;
        await axios.put(
          this.$routes.subject(this.subject.id),
          { format: 'json', ...this.form },
          {
            headers: { 'Content-Type': 'multipart/form-data' },
            onUploadProgress: function (progressEvent) {
              self.loadingProgress = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total,
              );
            },
          },
        );
        this.form.reset('subject');
        this.$emit('success');
      } catch (err) {
        console.log(err);
      } finally {
        this.loading = false;
        this.loadingProgress = 0;
      }
    },
  },
};
</script>
